export default __webpack_public_path__ + "static/Крысиные бега_18-719cff740b953440601d8e094028f1f3.jpg";